// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"showSetup_modalBodyStyle__3c1p9","modal":"showSetup_modal__JGexJ","gridImage":"showSetup_gridImage__6JaTt"};